import axAPI from "../api/axios-instance";

export type CmsMe = {
  keycloakId: string;
  login?: string;
  fullName?: string;
  isAdmin: boolean;
  allowedSections: string[];
};

let mePromise: Promise<CmsMe> | null = null;

/**
 * Текущий пользователь и его доступы. Кэшируется на сессию;
 * сбрасывается при login/logout (см. authProvider).
 */
export const fetchMe = (): Promise<CmsMe> => {
  if (!mePromise) {
    mePromise = axAPI
      .get<CmsMe>("/cms/me")
      .then((response) => response.data)
      .catch((error) => {
        // не кэшируем ошибку — следующий вызов попробует снова
        mePromise = null;
        throw error;
      });
  }
  return mePromise;
};

export const clearMe = () => {
  mePromise = null;
};
